import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  addPDMCurriculamTimeline,
  addPDMSummit,
  getPDMCurriculamTimeline,
  getPDMSummit,
} from "./ProductPageSubtitesAPi";

const initialState: any = {
  loading: {
    add_summit: false,
    get_summit: false,
    add_timeline: false,
    get_timeline: false,
  },
  req_success: {
    add_summit: false,
    get_summit: false,
    add_timeline: false,
    get_timeline: false,
  },
  pdm_summit: {},
  pdm_timeline: {},
};
// addPDMSummit
const ProductPageSubtitlesSlice = createSlice({
  name: "ProductPageSubtitlesSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //  addPDMSummit
    builder.addCase(addPDMSummit.pending, (state) => {
      state.loading.add_summit = true;
      state.req_success.add_summit = false;
    });
    builder.addCase(
      addPDMSummit.fulfilled,
      (state, { payload }: PayloadAction<any>) => {
        state.loading.add_summit = false;
        state.req_success.add_summit = true;
        state.pdm_summit = payload.data;
      }
    );
    builder.addCase(addPDMSummit.rejected, (state) => {
      state.loading.add_summit = false;
    });

    // getPDMSummit
    builder.addCase(getPDMSummit.pending, (state) => {
      state.loading.get_summit = true;
      state.req_success.get_summit = false;
      state.req_success.add_summit = false;
    });
    builder.addCase(
      getPDMSummit.fulfilled,
      (state, { payload }: PayloadAction<any>) => {
        state.loading.get_summit = false;
        state.req_success.get_summit = true;
        state.req_success.add_summit = true;
        state.pdm_summit = payload.data;
      }
    );
    builder.addCase(getPDMSummit.rejected, (state) => {
      state.loading.get_summit = false;
      state.req_success.add_summit = false;
    });

    builder.addCase(addPDMCurriculamTimeline.pending, (state) => {
      state.loading.add_timeline = true;
      state.req_success.add_timeline = false;
    });
    builder.addCase(
      addPDMCurriculamTimeline.fulfilled,
      (state, { payload }: PayloadAction<any>) => {
        state.loading.add_timeline = false;
        state.req_success.add_timeline = true;
        state.pdm_timeline = payload.data;
      }
    );
    builder.addCase(addPDMCurriculamTimeline.rejected, (state) => {
      state.loading.add_timeline = false;
    });

    builder.addCase(getPDMCurriculamTimeline.pending, (state) => {
      state.loading.get_timeline = true;
      state.req_success.get_timeline = false;
    });
    builder.addCase(
      getPDMCurriculamTimeline.fulfilled,
      (state, { payload }: PayloadAction<any>) => {
        state.loading.get_timeline = false;
        state.req_success.get_timeline = true;
        state.req_success.add_timeline = true;
        state.pdm_timeline = payload.data;
      }
    );
    builder.addCase(getPDMCurriculamTimeline.rejected, (state) => {
      state.loading.get_timeline = false;
    });
  },
});
export default ProductPageSubtitlesSlice.reducer;
